<template>
  <v-chip small class="items-chip" color="lightGrey">
    <Typography variant="caption-1">{{ chipLabel }}</Typography>
  </v-chip>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "ItemsChip",
  components: {
    Typography,
  },
  props: {
    numberOfItems: {
      type: Number,
      required: true,
    },
  },
  computed: {
    chipLabel() {
      return this.numberOfItems === 1
        ? `${this.numberOfItems} item`
        : `${this.numberOfItems ?? 0} items`;
    },
  },
};
</script>

<style scoped>
.items-chip {
  pointer-events: none;
  cursor: default;
  padding: 0.5rem;
}
</style>
